import { Fragment, type ReactNode } from "react";

// US-86: свободный текст комментариев к таймшиту часто содержит ссылки на
// задачи (Jira: https://jira.devsun.ru/browse/CADIC-78). Раньше они выводились
// просто текстом — нельзя кликнуть. Превращаем http(s)-URL в кликабельные
// ссылки (новая вкладка, безопасный rel). Только http/https — относительные
// пути и mailto осознанно НЕ линкуем, чтобы не угадывать неверно.

// split с capturing group → массив чередует текст и URL-куски.
const URL_SPLIT = /(https?:\/\/[^\s]+)/g;
const isUrl = (s: string): boolean => /^https?:\/\/\S+$/.test(s);

export interface LinkifyProps {
  text: string;
  /** Цвет ссылки (по умолчанию индиго). */
  color?: string;
}

/**
 * Рендерит строку, превращая http(s)-URL в кликабельные `<a target=_blank>`.
 * `stopPropagation` на клике — чтобы клик по ссылке внутри кликабельной
 * строки/ячейки не срабатывал как клик по строке.
 */
export function Linkify({ text, color }: LinkifyProps): ReactNode {
  if (!text) return null;
  const linkColor = color ?? "var(--mantine-color-indigo-6, #5b6be0)";
  const parts = text.split(URL_SPLIT);
  return (
    <>
      {parts.map((part, i) =>
        isUrl(part) ? (
          <a
            key={i}
            href={part}
            target="_blank"
            rel="noopener noreferrer"
            onClick={(e) => e.stopPropagation()}
            style={{ color: linkColor, wordBreak: "break-all" }}
          >
            {part}
          </a>
        ) : (
          <Fragment key={i}>{part}</Fragment>
        ),
      )}
    </>
  );
}
